// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "value-3vuQU";
var _4 = "code-1rRev";
var _5 = "wrapper_alternative-1PfCo";
export { _1 as "__esModule", _2 as "mobile", _3 as "value", _4 as "code", _5 as "wrapper_alternative" }
export default { "__esModule": _1, "mobile": _2, "value": _3, "code": _4, "wrapper_alternative": _5 }
